interface AnimatedPromptProps {
  text: string;
}

export default function AnimatedPrompt({ text }: AnimatedPromptProps) {
  return (
    <div className="relative text-center w-full" key={text}>
      <div className="w-full overflow-hidden">
        <svg
          width="100%"
          height="100%"
          preserveAspectRatio="none"
          viewBox="0 0 450 202"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M57.4174 177.997L39.6702 145.393L0 68.5393L57.4174 24.2905L125.274 0.0701294L449.943 16.3725V140.735L433.762 171.942L363.817 201.752C338.588 197.404 281.032 189.735 252.636 193.833C217.142 198.957 161.291 188.71 134.148 188.71C112.434 188.71 73.9466 181.568 57.4174 177.997Z"
            fill="#99D9D9"
          />
          <path
            d="M358.761 178.463C376.401 170.096 394.922 162.403 413.587 155.955C423.479 134.916 435.231 114.408 442.096 92.3488C430.344 63.5557 393.253 45.5575 369.059 23.825C285.652 35.783 198.742 46.7819 113.333 53.1486C58.5317 58.3726 72.7625 48.1899 46.4701 90.7571C52.1672 107.47 65.2062 143.997 74.2166 160.097C110.044 165.138 148.231 165.893 184.773 170.117C243.556 175.3 301.576 165.893 358.761 178.463Z"
            fill="white"
          />
        </svg>
      </div>
      <div className="absolute top-1/2 left-1/2 w-[85%] max-w-3xl transform -translate-x-1/2 -translate-y-1/2 text-[#d51668] font-bold text-center">
        <p className="text-[#d51668] text-2xl max-w-[400px] leading-[34px] pl-[30px] text-center font-bold">
          {text}
        </p>
      </div>
    </div>
  );
}
